<template>
    <q-table
        class="sticky-header-table"
        :data="usersAffiliated"
        :columns="columns"
        :filter="filter"
        :pagination.sync="paginationAux"
        :rows-per-page-options="[10, 20, 50, 100]"
        :loading="loading"
        binary-state-sort
        row-key="user_id"
        flat
        @request="request"
    >
        <!-- top -->
        <template v-slot:top>
            <slot name="top" />
        </template>
        <!-- units owned by this order -->
        <template v-slot:body-cell-assigned_in_this_order="props">
            <q-td key="assigned_in_this_order" :props="props">
                {{ assignedInOrder(props.row.users.libraries) }}
            </q-td>
        </template>
        <!-- units owned outside this order -->
        <template v-slot:body-cell-assigned_outside_this_order="props">
            <q-td key="assigned_outside_this_order" :props="props">
                {{ assignedOutOrder(props.row.users.libraries) }}
            </q-td>
        </template>
        <!-- column actions -->
        <template v-slot:body-cell-actions="props">
            <q-td key="actions" :props="props">
                <q-btn
                    icon="add"
                    color="secondary"
                    dense
                    :disable="coursesAvailableToGive <= 0"
                    @click="assignCourse(props.row)"
                ></q-btn>
            </q-td>
        </template>
    </q-table>
</template>

<script>
export default {
    name: 'AddEmployeeTable',

    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        filter: {
            type: String,
            default: null,
        },
        columns: {
            type: Array,
            default: () => [],
        },
        usersAffiliated: {
            type: Array,
            default: () => [],
        },
        usersWithCourse: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => {},
        },
        orderItemCourse: {
            type: Object,
            default: () => {},
        },
        coursesAvailableToGive: { type: Number, default: 0 },
    },

    data() {
        return {
            paginationAux: {},
            filterAux: {},
        }
    },

    computed: {},

    watch: {
        pagination(value) {
            this.paginationAux = value
        },

        filter(value) {
            this.filterAux = value
        },
    },

    mounted() {
        this.paginationAux = this.pagination
        this.filterAux = this.filter
    },

    methods: {
        request(props) {
            const { page, rowsPerPage, sortBy, descending } = props.pagination
            const filter = props.filter

            this.paginationAux.page = page
            this.paginationAux.rowsPerPage = rowsPerPage
            this.paginationAux.sortBy = sortBy
            this.paginationAux.descending = descending

            this.filterAux = filter

            this.$emit('request', this.paginationAux, this.filterAux)
        },

        hasCourse(user) {
            return this.usersWithCourse.find(
                (userWithCourse) => userWithCourse.user_id === user.user_id
            )
                ? true
                : false
        },

        assignCourse(user) {
            this.$emit('assign-course', {
                user: user,
                course: this.orderItemCourse,
            })
        },

        assignedInOrder(libraries) {
            if (libraries.length) {
                return libraries.filter(
                    (library) =>
                        library.order_item_id === this.orderItemCourse.id
                ).length
            }
            return 0
        },

        assignedOutOrder(libraries) {
            if (libraries.length) {
                return libraries.filter(
                    (library) =>
                        library.order_item_id !== this.orderItemCourse.id
                ).length
            }
            return 0
        },
    },
}
</script>
